import { render, staticRenderFns } from "./AddHorse.vue?vue&type=template&id=b69b874e&"
import script from "./AddHorse.vue?vue&type=script&lang=js&"
export * from "./AddHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports